export default "__VITE_ASSET__2e10a055__"